module.exports = __webpack_public_path__ + "static/media/vtt.2d9d424d.jpg";